import { useDeviceSetting } from "@-/dev.improve.haniverse.lib.device-settings";
import { Stack } from "@-/com.npmjs.expo-router";
import { BrowseLayoutContextProvider } from "@-/dev.improve.haniverse.routes.nav.app.browse._context";
import { ActivityIndicator, View } from "@-/com.npmjs.react-native";

/** Own the router's internal boundaries as well as the boundaries inside Browse pages. */
export function SuspenseFallback() {
  return (
    <View
      accessibilityLabel="Loading browse"
      className="flex-1 items-center justify-center bg-background"
      testID="browse-route-loading"
    >
      <ActivityIndicator />
    </View>
  );
}

// Anchor the stack to the tabs pager. React Navigation seeds a stack's initial state from
// `options.initialRouteName ?? routeNames[0]`, and explicitly declared `<Stack.Screen>` children are
// registered BEFORE the filesystem routes — so the `morpheme` screen below (declared only to set its
// transition) silently became `routeNames[0]`. Every fresh seed of this stack (first
// focus of the Browse tab, rehydration after a reload) therefore landed on `morpheme/[morpheme]`
// with NO `morpheme` param, which renders `MorphemeNotFound` as `Character not found: ""`. It also
// left that paramless entry *underneath* every later push, so the panel toolbar's back chevron
// (visible whenever the morpheme stack index is > 0) had a dead entry to go back to.
export const unstable_settings = {
  anchor: "(browse-tabs)",
};

// A `<Stack>` (not a `<Slot>`) so pushing a detail route on top of the browse tabs keeps the
// tab scene MOUNTED underneath. The three siblings — `(browse-tabs)` (the Levels/Characters/
// Primitives/Words pager), `morpheme` (character detail), and `g` — are all reached
// by `router.push` from within a browse tab, and a plain `<Slot>` renders only the top route and
// unmounts the one beneath it. That unmounted the entire `(browse-tabs)` pager (and its Levels
// list) on every morpheme push, so returning re-mounted it from empty — a blank flash + a full
// study-query refetch. `<Stack>` keeps the previous screen alive, so back-navigation reveals the
// already-rendered tab instantly. Each sibling keeps its own `_layout.tsx` `screenOptions`
// (all `headerShown: false`); this Stack sets the same so no native header appears (the app's
// own header is rendered up in `NavLayout`). Screens are auto-discovered from the filesystem, so
// every route opens immediately; character pages show content skeletons while their data loads.
export default function BrowseLayoutRoute() {
  const [isEdgeNavigationEnabled] = useDeviceSetting("isEdgeNavigationEnabled");
  return (
    <BrowseLayoutContextProvider>
      <Stack
        screenOptions={{
          animation: "none",
          animationMatchesGesture: false,
          fullScreenGestureEnabled: false,
          gestureEnabled: isEdgeNavigationEnabled,
          headerShown: false,
        }}
      >
        <Stack.Screen name="(browse-tabs)" options={{ animation: "none" }} />
        <Stack.Screen name="morpheme" options={{ animation: "none" }} />
      </Stack>
    </BrowseLayoutContextProvider>
  );
}
